import { SearchOutlined } from '@ant-design/icons';
import { Input, theme } from 'antd';
import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react';
export const SearchInput = forwardRef(({ autoFocus, className, debounceDelay = 300, defaultValue, id, onChange, placeholder = 'Search', size }, ref) => {
    const { token } = theme.useToken();
    const [text, setText] = useState(defaultValue);
    const inputRef = useRef(null);
    const onChangeRef = useRef(onChange);
    const timeoutRef = useRef(0);
    useImperativeHandle(ref, () => ({
        inputRef: inputRef.current,
        setText: (value) => setText(value)
    }), []);
    onChangeRef.current = onChange;
    const handleChange = useCallback((e) => {
        var _a, _b;
        const value = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value;
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
            var _a;
            onChangeRef.current((_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : '');
        }, debounceDelay);
        setText((_b = e.target) === null || _b === void 0 ? void 0 : _b.value);
    }, [debounceDelay]);
    return (React.createElement(Input, { allowClear: true, autoFocus: autoFocus, className: className, defaultValue: defaultValue, id: id, onChange: handleChange, placeholder: placeholder, ref: inputRef, size: size, suffix: !text && React.createElement(SearchOutlined, { style: { color: token.colorTextPlaceholder } }), title: 'Search', value: text }));
});
